<template>
  <div id="app">
    <!--导航条-->
    <gheader type="home"></gheader>
    <!--logo一行-->
    <glogo></glogo>
    <!--红色导航-->
    <grednav type="home"></grednav>
    <div class="row-agreement">
      <div class="main-width">
        <div id="agreement">
          <h2 id="title">采购门户注册协议</h2>
          <div id="source">
            <p> </p>
          </div>
          <div id="content">
            <p>注册用户协议：<br>
              欢迎来到{{companyName}}采购门户，如您确定成为本网用户，必须遵守本协议，如表示同意，您即与{{companyName}}签定入网协议，并受本协议约束，请仔细审阅。</p>
            <p>一、注册须知。<br>
              1、申请参加{{companyName}}采购活动的供应商，必须在{{companyName}}电子采购平台上进行注册登记，并应具备以下条件：<br>
              （1）依法成立，具有独立承担民事责任的能力，具有法人资格或得到企业法人的授权；<br>
              （2）具有良好的商业信誉和健全的财务会计制度；<br>
              （3）具有履行合同所必备的能力和信誉；<br>
              （4）具有与所供应的产品相适应的销售资质，如非生产厂家，需有所销售产品生产厂家的经销授权；<br>
              （5）近三年经营活动中无违法、违规记录和重大法律纠纷；<br>
              （6）提供的产品必须符合国家质量标准,取得相应的质量认证；<br>
              （7）项目要求的其他必备条件。<br>
              2、本平台目前不收服务费用，一旦本平台发出公告决定收费，注册用户必须根据本平台的相关规定按时足额交纳服务费用，否则将不能继续使用本平台。<br>
              3、供应商应承诺网上注册登记的全部信息和注册入库后所登记、变更的信息，以及为注册登记所提供的一切附件资料合法、真实、准确和有效，并依法、诚信参与{{companyName}}采购活动，如有弄虚作假或其他违法违规行为，将取消其平台注册资格并按政府采购法相关法律法规规定作出相关处罚。
            </p>
            <p>二、用户的权利与责任。<br>
              1、权利<br>
              （1）您可以在本网站上传资质文件和下载标书、查看所投标项目的相关信息，并进行投标、竞价。<br>
              （2）如您发现在本网站上有操作或质疑的问题，有查询和澄清的权利。<br>
              （3）有权对{{companyName}}相关业务及人员进行投诉，欢迎您进行监督。<br>
              2、责任<br>
              （1）必须保证所提供资质的真实性和准确性。如提供虚假信息，将被永久取消给{{companyName}}平台采购商供货或竞买资格，并承担由此造成的后果。<br>
              （2）中标单位必须在规定期限内签订并履行合同。<br>
              （3）不得将登录帐号转给其他单位或个人使用，否则，您将承担因此给造成的后果。<br>
              （4）不利用登录帐号对本网站非法登录或进行数据破坏活动。<br>
              （5）如果您的用户名和密码因保管不善丢失或泄露，应立即书面通知{{companyName}}服务人员，申请停用；否则，由此引起的后果，由您承担。停止使用期间，将无法进行业务；如需要继续进行业务，须重新设置用户名和密码，并将您的承诺书书面提交{{companyName}}服务人员，{{companyName}}服务人员可重新给予开通业务。
            </p>
            <p>
              三、与{{companyName}}开展业务的办事程序：<br>
              （1）新单位注册，在网上提交您的相关资质，{{companyName}}审核通过后，可参与{{companyName}}采购门户后续业务。<br>
              （2）可在电子采购交易平台上完成标书下载或获取竞价信息。<br>
              （3）网上投标或竞价。<br>
              （4）招标方组织网上开标。<br>
              （5）招标方在网上发布中标公告。<br>
              （6）签定并执行合同。
            </p>
            <p>
              四、本网站的权利与责任<br>
              1、权利<br>
              （1）当用户违反相关法律法规或本协议规定，以及本公司规章制度时，本网站有权取消其信息的发布或入网权限，直至追究法律责任。<br>
              （2）当网站出现安全方面的紧急状况时，本网站有权短时间暂停服务。<br>
              2、责任<br>
              （1）本网站有责任保证信息的准确性。<br>
              （2）本网站有责任保证信息的安全性。<br>
            </p>
            <p>
              五、适用法律、法规<br>
              1、《中华人民共和国公安部计算机安全法》<br>
              2、《中华人民共和国招投标法》<br>
              3、《中华人民共和国合同法》<br>
              4、《招标公告发布暂行办法》<br>
              5、《评标委员会和评标方法暂行规定》<br>
              6、《中华人民共和国政府采购法实施条例》
            </p>
            <p>
              六、免责声明<br>
              以下情况本网站声明免责：<br>
              1、本网已经采取合理的防电脑病毒手段，但仍遭受电脑病毒破坏的致使用户资料受损，以及产生的后果不承担任何责任。<br>
              2、本网已经采取合理的防电脑黑客入侵手段，但仍遭受电脑黑客入侵致使用户资料受损或被窃取，以及产生的后果不承担任何责任。<br>
              3、因计算机设施或操作系统软件本身固有的技术缺陷而引起的用户资料数据受损或被窃取，以及产生的后果不承担任何责任。<br>
              4、无法预见、无法避免且无法克服的其它不可抗情况，本网站不承担任何责任。<br>
              5、本网站对任何因用户不正当或非法使用服务，及用户发布言论、信息而产生的直接、间接、偶然、特殊及后续的损害不承担任何责任。<br>
              6、本网站对因第4条规定的不可抗力原因造成的服务中断或不能满足用户的要求及产生后果不承担任何责任。<br>
              7、由于通信线路、网络、用户所在位置以及其它任何技术原因导致用户不能接受本网服务时，本网站不承担任何责任。<br>
              8、对于因注册用户提交资料不准确或不及时更新其资料而给他人或自己造成的任何损失、影响及风险，本网站不承担任何责任。
            </p>
          </div>
          <div id="continue">
            <button class="btn btn-info" @click="enterlink()">同意并继续</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gheader from 'components/G-header'
  import glogo from 'components/G-logo'
  import grednav from 'components/G-rednav'
  import {apiLinks} from '../../api/links.js'

  export default {
    name: 'app',
    components: {
      gheader,
      glogo,
      grednav
    },
    data () {
      return {
        companyName: apiLinks.companyname
      }
    },
    methods: {
      enterlink: function () {
        let str = window.location.href
        let array = str.split('?')
        if (array[1] === 'register') {
          window.location.href = apiLinks.register
        } else if (array[1] === 'applyFor') {
          window.location.href = apiLinks.suppliersFor
        }
      }
    }
  }
</script>
<style>
  #agreement {
    width: 980px;
    min-height: 650px;
    margin: 50px auto;
    box-shadow: 0 2px 6px #999;
    _border: 1px #dedede solid;
    padding: 15px;
  }

  #title {
    text-align: center !important;
    font-size: 26px;
    font-weight: 400;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  #source > p {
    width: 950px;
    margin: 0 auto;
    border-bottom: 1px solid #E5E5E5;
    margin-bottom: 20px;
    color: #999;
    line-height: 30px;
    padding-bottom: 5px;
    text-align: center;
  }

  #content > p {
    font-size: 12px;
    font-family: "Microsoft YaHei", Arial, Verdana, sans-serif;
    background: #ffffff;
    color: #333;
    margin: 0 0 10px;
    line-height: 30px;
  }

  #continue {
    text-align: center;
  }

  #continue > button {
    width: 120px;
    height: 34px;
    margin: 80px auto;
  }
</style>



// WEBPACK FOOTER //
// agreement.vue?11ed00b0